module.exports = __webpack_public_path__ + "static/img/banner05.6cfbe787.png";